import React, { useEffect, useState } from "react";
import { useLoading } from "../../LoadingContext"; 

function Preloader() {
  const { loading, setLoading } = useLoading();
  const [fadeOut, setFadeOut] = useState(false);
  const [render, setRender] = useState(true);

  useEffect(() => {
    setLoading(true)
    const timer = setTimeout(() => {
      setLoading(false);
      setFadeOut(true);
    }, 1000);

    const removePreloader = setTimeout(() => {
        setRender(false);
      }, 1500); // this should be after the end of the fadeOut transition.

    return () => {
      clearTimeout(timer);
      clearTimeout(removePreloader);
    };
  }, []);


  useEffect(() => {
    if (loading) {
      document.body.classList.add('loading-active');
      document.documentElement.classList.add('loading-active'); 
    } else {
      document.body.classList.remove('loading-active');
      document.documentElement.classList.remove('loading-active');
    }
  }, [loading]);

  return (
    render && (
      <div id="perloader">
        <div className={`preloader-container ${fadeOut ? "fade-out" : ""}`}>
          <div className="logo-container">
            <img
              src={"/assets/images/logo/cus-logo.png"}
              alt="logo"
              className="logo"
            />
          </div>
          <div className="spinner-container">
            <div className="spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default Preloader;
